<!-- eslint-disable no-empty -->
<template>
  <slot v-if="isApple"></slot>
</template>

<script>
export default {
  data() {
    return {
      isApple: false
    }
  },

  created() {
    // fungje jen se zaplym HTTPS
    try {
      this.isApple = window.ApplePaySession && window.ApplePaySession.canMakePayments()
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}
</script>
